import { morphism, StrictSchema } from 'morphism';
import { ITipConfigurationApi, ITipState } from './type';

const tipSchemaForState: StrictSchema<ITipState, ITipConfigurationApi> = {
  tipToggle: 'enabled',
  tipOptions: {
    option1: 'option1',
    option2: 'option2',
    option3: 'option3',
  },
};

const tipSchemaForApi: StrictSchema<ITipConfigurationApi, ITipState> = {
  enabled: 'tipToggle',
  option1: 'tipOptions.option1',
  option2: 'tipOptions.option2',
  option3: 'tipOptions.option3',
};

export const transformTipConfigForState = (tipFromApi: ITipConfigurationApi): ITipState => {
  return morphism(tipSchemaForState, tipFromApi);
};

export const transformTipConfigForApi = (tipFromState: ITipState): ITipConfigurationApi => {
  return morphism(tipSchemaForApi, tipFromState);
};
